export default "__VITE_ASSET__qPGe9tSw__"